import createTheme from "@mui/material/styles/createTheme";

import typography from "./typography";

export const customPalette = {
  primary: {
    light: "#000",
    main: "#971FE3",
    dark: "#6E0EAB",
  },
  secondary: {
    light: "#F4F5F6",
    main: "#018AF8",
    dark: "#1075C7",
  },
  lightGray: {
    main: "#828282",
    light: "",
    dark: "",
    contrastText: "",
  },
  text: {
    primary: "#27334B",
    secondary: "#9E9E9E",
  },
  divider: "#D8D8D8",
  background: {
    default: "#F9F2FD",
  },
  info: {
    light: "#dee9fb",
    main: "#858e9c",
  },
  error: {
    main: "#EF1B1B",
  },
};

const palette = createTheme({
  // TODO: add correct colors
  typography,
  palette: customPalette,
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 768,
      lg: 1024,
      xl: 1440,
    },
  },
});

export default palette;
